import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

// Simple route guards to get you started
export const PrivateRoute = ({ children }) => {
  const { isLoggedIn, isLoading } = useAuth();
  
  if (isLoading) return <div>Loading...</div>;
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  
  return children;
};

export const PermissionRoute = ({ children, requiredPermission }) => {
  const { isLoggedIn, isLoading } = useAuth();
  
  if (isLoading) return <div>Loading...</div>;
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  
  // For now, just return children - we'll add permission checking later
  return children;
};

export const SubscriptionRoute = ({ children, allowTrial }) => {
  const { isLoggedIn, isLoading } = useAuth();
  
  if (isLoading) return <div>Loading...</div>;
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  
  // For now, just return children - we'll add subscription checking later
  return children;
};

export const GuardedRoute = ({ children }) => {
  return children;
};